const styles = {
  container: {
    height: "100vh",
    width: "286px",
  },
  containerOpen: {
    height: "98vh",
    backgroundColor: "#EEEEEE",
  },
  searchOptionsContainer: {
    paddingTop: 15,
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 2,
  },
  mobileWide: {
    "@media screen and (max-width: 1200px)": {
      width: "100vw !important",
      position: "fixed !important",
    },
  },
  spacer: {
    width: "100%",
    height: "72px",
    boxShadow: "2px 0 0px 0 rgb(0 0 0 / 10%)",
    backgroundColor: "#FFFFFF",
    position: "relative",
    zIndex: 1,
  },
  startHolder: {
    width: "100%",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    position: "relative",
    zIndex: 0,
    boxShadow: "7px 0 4px -5px rgb(0 0 0 / 10%)",
    "@media (max-width: 1200px)": {
      boxShadow: "2px 0 4px 0 rgb(0 0 0 / 10%)",
    },
  },
  hideTopMobile: {
    "@media screen and (max-width: 1200px)": {
      display: "none",
    },
  },
  arrowContainer: {
    marginTop: "23px",
    marginLeft: "15px",
    display: "none",
    "@media screen and (max-width: 1200px)": {
      display: "block",
    },
  },
  closeContainer: {
    marginTop: "23px",
    marginRight: "15px",
    display: "none",
    "@media screen and (max-width: 1200px)": {
      display: "block",
    },
  },
  dynamicHeight: {
    height: "211px",
    "@media screen and (max-width: 1200px)": {
      height: "121px",
    },
  },
  topContainer: {
    height: "176px",
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "2px 0 4px 0 rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    boxSizing: "border-box",
  },
  bottomContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#eeeeee",
    paddingTop: "10px",
    paddingBottom: "10px",
    boxShadow: "2px 0 4px 0 rgb(0 0 0 / 10%)",
    height: "calc(100% - 162px)",
  },
  button: {
    backgroundColor: "Transparent",
    backgroundRepeat: "no-repeat",
    border: "none",
    cursor: "pointer",
    outline: "none",
    fontFamily: "CircularStd",
    color: "#6373A4",
    "&:focus": {
      outline: "none",
    },
    "@media (max-width: 1200px)": {
      fontSize: "16px",
    },
  },
  stickyPadding: {
    width: 286,
  },
  // Portrait
  "@media (max-width: 1200px)": {
    container: {
      maxWidth: 375,
      width: "100%",
      height: "calc(100vh - 30px)",
    },
    topContainer: {
      width: "100%",
      boxShadow: "0 0 2px 0 rgba(0,0,0,0.1)",
    },
    bottomContainer: {
      paddingTop: "7px",
      paddingLeft: "7px",
      paddingRight: "7px",
      position: "relative",
    },
    stickyPadding: {
      width: "unset",
    },
  },
};

export default styles;
